import { Button, Divider, Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config';
import axios from 'axios';
import { useSSR } from 'react-i18next';
import { CreatedToast, ErrorToast, UpdatedToast } from '../../views/ToastComponent';

function SweetShopAllDetails() {

    const { itemId } = useParams()

    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const [singleData, setSingleData] = useState([])


    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/item/material/getbyitemid/${itemId}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })

            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [sweetShopDetailsData, setSweetShopDetails] = React.useState({
        sweetItemId: itemId,
        unitId: 0,
        name: "",
        quantity: 0,
        price: 0,
        totalAmount: 0,
        latitude: "",
        longitude: ""
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setSweetShopDetails({ ...sweetShopDetailsData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item/material`, sweetShopDetailsData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                CreatedToast("Created Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something Went Wrong!!")
            return error.message
        }
    }

    const [unitData, setUnitData] = useState([])

    const handleAllUnitsFunc = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Unit`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setUnitData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        handleAllUnitsFunc()
    }, [])


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/SweetShopPd/item/material/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSweetShopDetails(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const calculateTotalReciepts = () => {
        const result = sweetShopDetailsData.quantity * sweetShopDetailsData.price || 0;

        setSweetShopDetails(prev => ({
            ...prev,
            totalAmount: result
        }))
    };

    useEffect(() => { calculateTotalReciepts() }, [sweetShopDetailsData.quantity, sweetShopDetailsData.price])

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/SweetShopPd/item/material/${id}`, sweetShopDetailsData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Updated Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went Wrong")
            return error
        }
    }


    async function handleCancel() {
        setSweetShopDetails({
            ...sweetShopDetailsData,
            sweetItemId: itemId,
            unitId: 0,
            name: "",
            quantity: 0,
            price: 0,
            totalAmount: 0,
        })
// reset form with initial value 0
        setIsModalOpen(false);
        setIsEditModalOpen(false)
    }


    const columns = [
        {
            title: "Item Name",
            dataIndex: "name",
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
        },
        {
            title: "Price",
            dataIndex: "price",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        // className='btn btn-secondary'
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //         <div>
        //             {text}
        //             <Button
        //                 className='btn btn-danger'
        //                 type="primary"
        //                 // onClick={() => handleClick(record.id)}
        //                 style={{ marginLeft: '10px' }}
        //             >
        //                 <i class="fa-solid fa-trash"></i>
        //             </Button>
        //         </div>
        //     ),
        // },
    ];

    return (
        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Add Raw Mateial</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Item</button>
                        </div>
                    </div>


                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={<h4>Add Shop</h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Add/Buisnss Shop</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Raw Material Name:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Raw Material Name" value={sweetShopDetailsData.name} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Quantity:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Quantity" value={sweetShopDetailsData.quantity} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, quantity: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Unit:
                                    </label>
                                    <select className="form-control" value={sweetShopDetailsData.unitId} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, unitId: e.target.value })}>
                                        <option value="">Selling Unit</option>
                                        {unitData && unitData.length > 0 && unitData.map((res) => (
                                            <option value={res.id}>{res.name} {res.description}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Rate:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Rate" value={sweetShopDetailsData.price} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, price: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Edit Modal */}
            
            <Modal
                title={<h4>Add Shop</h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[

                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(sweetShopDetailsData.id)}>Submit</button>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Add/Buisnss Shop</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Raw Material Name:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Raw Material Name" value={sweetShopDetailsData.name} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Quantity:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Quantity" value={sweetShopDetailsData.quantity} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, quantity: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Selling Unit:
                                    </label>
                                    <select className="form-control" value={sweetShopDetailsData.unitId} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, unitId: e.target.value })}>
                                        {unitData && unitData.length > 0 && unitData.map((res) => (
                                            <option value={res.id}>{res.name} {res.description}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Rate:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Rate" value={sweetShopDetailsData.price} onChange={(e) => setSweetShopDetails({ ...sweetShopDetailsData, price: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default SweetShopAllDetails